import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.level1,
    margin: "0 auto",
    flexGrow: "1",
    maxWidth: "600px",
    padding: "0 1rem",
    [theme.breakpoints.down('sm')]: {
      margin: "0 1rem",
      padding: "0 0.5rem",
    },
  },
  logo: {
    display: "block",
    padding: "2rem 0 1.5rem 0",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "6.25rem",
    [theme.breakpoints.down('sm')]: {
      padding: "1.5rem 0 1rem 0",
      maxWidth: "5rem",
    },
  },
  loadingSpinner: {
    display: "flex",
    justifyContent: "center",
  },
  walletBadgeWrapper: {
    border: "none",
    background: "transparent",
    padding: 0,
    cursor: "pointer",
    transition: "opacity 0.3s ease",
    display: "flex",
    justifyContent: "center",
    "&:hover": {
      opacity: 0.8,
    },
  },
  walletBadge: {
    display: "inline-block",
    height: "75px",
    width: "auto",
    [theme.breakpoints.down('sm')]: {
      height: "2.5rem",
    },
  },
}));
